import React, { PropsWithChildren } from 'react'

import { Footer, Header, ScrollToTop } from 'Components/Blocks'
import { Column } from 'Components/UI'

import { HEADER_HEIGHT_PX } from 'Constants/Navigation'
import { Z_INDICES } from 'Constants/ZIndices'

import { useResponsiveLayout } from 'Hooks'

import { Container } from './styles'

function PublicInviteLayout({ children }: PropsWithChildren) {
  const { isDesktop } = useResponsiveLayout()

  return (
    <Container>
      <ScrollToTop />

      <Column grow relative>
        <Header secondary />

        <Column
          alignCenter
          grow
          pt={isDesktop ? HEADER_HEIGHT_PX.DESKTOP : 0}
          zIndex={Z_INDICES.BASE_CONTENT}
        >
          {children}
        </Column>
      </Column>

      <Footer secondary />
    </Container>
  )
}

export default PublicInviteLayout
